/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';
// import { ColorPaletteProp } from '@mui/joy/styles';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import ButtonGroup from '@mui/joy/ButtonGroup';
import Chip from '@mui/joy/Chip';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Link from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import Checkbox from '@mui/joy/Checkbox';
import IconButton, { iconButtonClasses } from '@mui/joy/IconButton';
import Typography from '@mui/joy/Typography';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import Dropdown from '@mui/joy/Dropdown';
import Tooltip from '@mui/joy/Tooltip';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import BlockIcon from '@mui/icons-material/Block';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { abbreviateNumber, formatNumber } from '@utils/numbers';
import { ToggleButtonGroup } from '@mui/joy';

/*
todo: mobile

- max pages to display
*/

export default function Paginate({
    tint,
    from,
    to,
    total,
    currentPage,
    perPage,
    lastPage,
    onChange
}) {

    const maxPagesAtOnce = 5;
    let pagesToRender = [];

    // possibly add left ... into the mix

    const hasPagination = !!from && !!to;

    return (<>
        <Box
            sx={{
                display: 'flex',
                flexDirection: {xs: 'row-reverse', sm: 'row'},
                alignItems: 'center',
                gap: 1.5,
                justifyContent: {xs: 'flex-end', sm: 'flex-start'},// 'flex-end',
                flex: {xs: 1, sm: 0}
            }}
        >
            <Typography
                fontSize={'xs'}
                whiteSpace={'nowrap'}
                sx={{
                    color: `${tint}.950`,
                    display: {
                        xs: 'none',
                        sm: 'initial',
                    }
                }}
            >
                {hasPagination && <>
                    {from}–{to} of {total >= 100 ? abbreviateNumber(total) : formatNumber(total)}
                </>}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <ButtonGroup
                    size="sm"
                    color="neutral"
                    variant="outlined"
                >
                    <Tooltip title={'Previous Page'}>
                        <Button
                            size="sm"
                            color="neutral"
                            variant="outlined"
                            disabled={currentPage === 1}
                            onClick={() => onChange(currentPage-1)}
                            sx={{
                                bgcolor: 'background.surface',
                                pl: '0.55rem',
                                '--Button-gap': '0.125rem',
                            }}
                            startDecorator={<KeyboardArrowLeftIcon />}
                        >
                            Prev
                        </Button>
                    </Tooltip>
                    <Tooltip title={'Next Page'}>
                        <Button
                            size="sm"
                            color="neutral"
                            variant="outlined"
                            disabled={currentPage === lastPage}
                            onClick={() => onChange(currentPage+1)}
                            sx={{
                                bgcolor: 'background.surface',
                                pr: '0.55rem',
                                '--Button-gap': '0.125rem',
                            }}
                            endDecorator={<KeyboardArrowRightIcon />}
                        >
                            Next
                        </Button>
                    </Tooltip>
                </ButtonGroup>
                {/*
                <Tooltip title={'Previous Page'}>
                <IconButton
                    size="sm"
                    color="neutral"
                    variant="outlined"
                    disabled={currentPage === 1}
                    onClick={() => onChange(currentPage-1)}
                    sx={{ bgcolor: 'background.surface' }}
                >
                    <KeyboardArrowLeftIcon />
                </IconButton>
                </Tooltip>
                <Tooltip title={'Next Page'}>
                <IconButton
                    size="sm"
                    color="neutral"
                    variant="outlined"
                    disabled={currentPage === lastPage}
                    onClick={() => onChange(currentPage+1)}
                    sx={{ bgcolor: 'background.surface' }}
                >
                    <KeyboardArrowRightIcon />
                </IconButton>
                </Tooltip>
                */}
            </Box>
        </Box>
    </>);

    /*
    return (
        <Box
            className="Pagination-laptopUp"
            sx={{
            pt: 2,
            gap: 1,
            // [`& .${iconButtonClasses.root}`]: { borderRadius: '50%' },
            display: {
                xs: 'none',
                md: 'flex',
            },
            }}
        >
            <ButtonGroup
                size="sm"
                variant="soft"
                color='neutral'
            >
                <IconButton
                    aria-label='Previous'
                    onClick={() => onChange(currentPage-1)}
                    disabled={currentPage === 1}
                >
                    <KeyboardArrowLeftIcon />
                </IconButton>

                <Button
                    endDecorator={<ArrowDropDownRoundedIcon/>}
                >
                    Page {currentPage}
                </Button>

                {/*
                {['1', '2', '3', '…', '8', '9', '10'].map((page) => (
                <IconButton
                    key={page}
                    // size="sm"
                    // variant={Number(page) ? 'outlined' : 'plain'}
                    // color="neutral"
                    aria-pressed={currentPage === parseInt(page)}
                >
                    {page}
                </IconButton>
                ))}
                *\/}

                <IconButton
                    aria-label='Next'
                    onClick={() => onChange(currentPage+1)}
                    disabled={currentPage === total}
                >
                    <KeyboardArrowRightIcon />
                </IconButton>

            </ButtonGroup>
        </Box>
    );
    */
}
